import cn from 'classnames';
import React from 'react';

import { block } from './utils';

export interface CreateTabCardContentsProps {
  children?: React.ReactNode;
  className?: string;
}

const CreateTabCardContents: React.FC<CreateTabCardContentsProps> = ({
  children,
  className,
}) => <div className={cn(block('contents'), className)}>{children}</div>;

export default CreateTabCardContents;
